// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/sections/home/admin/admin.scss
// module id = 1156
// module chunks = 0